<template>
  <div class="mfa-code-input">
    <div class="request-new-code">
      <span><slot name="txtNoCodeReceived"/></span>
      <button
        type="button"
        class="btn text"
        :disabled="isWaiting"
        @click="requestNewCode"
      >
        <slot name="txtResend"/>
      </button>
    </div>
    <fieldset class="input-group">
      <label for="codeInput" class="code-input--label">
        <slot name="lblCode"/>
      </label>
      <input
        v-for="(digit, index) in code"
        :key="index"
        name="codeInput"
        ref="inputs"
        v-model="code[index]"
        type="text"
        maxlength="1"
        inputmode="numeric"
        autocomplete="one-time-code"
        pattern="[0-9]*"
        class="otp-input"
        :aria-label="'Ziffer ' + (index + 1)"
        @input="handleInput($event, index)"
        @keydown.delete="handleDelete(index)"
        @keypress="allowOnlyNumbers"
        @paste="handlePaste"
      />
    </fieldset>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import trackingHandler from '@/mixins/trackingHandler'

const codeLength = 6

export default {
  name: 'MfaCodeInput',
  mixins: [trackingHandler],
  data () {
    return {
      code: Array(codeLength).fill(''),
      waitTime: 30,
      timer: null,
      isWaiting: false
    }
  },
  mounted () {
    this.startCountdown()
  },
  methods: {
    ...mapActions('mfa', ['initiateMfa']),

    async requestNewCode () {
      if (this.isWaiting) return

      try {
        await this.initiateMfa()
        this.successToast(this.getSlotText('txtCodeSentSuccessfully'))
      } catch (error) {
        this.errorToast(this.getErrorMessage(error))
      } finally {
        this.startCountdown()
      }
    },

    startCountdown () {
      this.isWaiting = true
      this.waitTime = 30

      clearInterval(this.timer) // clear existing timer
      this.timer = setInterval(() => {
        this.waitTime--
        if (this.waitTime <= 0) {
          clearInterval(this.timer)
          this.isWaiting = false
        }
      }, 1000)
    },

    handleInput (event, index) {
      const value = event.target.value.replace(/\D/g, '')
      if (value) {
        this.code[index] = value
        this.focusNext(index)
      } else {
        this.code[index] = ''
      }
    },

    focusNext (index) {
      if (index < this.code.length - 1) {
        this.$refs.inputs[index + 1]?.focus()
      }
    },

    handleDelete (index) {
      if (!this.code[index] && index > 0) {
        this.$refs.inputs[index - 1]?.focus()
      }
    },

    handlePaste (event) {
      const pasteData = event.clipboardData.getData('text').slice(0, 6).replace(/\D/g, '')
      if (pasteData.length === 6) {
        this.code = pasteData.split('')
        this.$refs.inputs[5]?.focus()
      }
    },

    allowOnlyNumbers (event) {
      if (!/^\d$/.test(event.key)) {
        event.preventDefault()
      }
    }
  },
  watch: {
    code: {
      deep: true,
      handler (newCode) {
        this.$emit('updated', newCode.join(''))
      }
    }
  }
}
</script>
